<div>
  <svg
    [attr.width]="width"
    [attr.height]="height"
    viewBox="0 0 12 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    [style.opacity]="opacity"
    class="transition-all duration-300"
  >
    <!-- Gradient ONLY if colors exist -->
    @if (hasGradient) {
      <defs>
        <linearGradient
          [attr.id]="gradientId"
          gradientUnits="userSpaceOnUse"
          x1="0"
          y1="0"
          x2="12"
          y2="19"
        >
          <stop offset="0%" [style.stop-color]="startColor" />
          <stop offset="100%" [style.stop-color]="endColor" />
        </linearGradient>
      </defs>
    }

    <path
      d="M10 0C10.2549 0.000282707 10.5 0.0978791 10.6854 0.272848C10.8707 0.447818 10.9822 0.686953 10.9972 0.941395C11.0121 1.19584 10.9293 1.44638 10.7657 1.64183C10.6021 1.83729 10.3701 1.9629 10.117 1.993L10 2V6.764L11.894 10.553C11.9463 10.6567 11.9801 10.7687 11.994 10.884L12 11V13C12 13.2449 11.91 13.4813 11.7473 13.6644C11.5845 13.8474 11.3603 13.9643 11.117 13.993L11 14H7V18C6.99972 18.2549 6.90212 18.5 6.72715 18.6854C6.55218 18.8707 6.31305 18.9822 6.05861 18.9972C5.80416 19.0121 5.55362 18.9293 5.35817 18.7657C5.16271 18.6021 5.0371 18.3701 5.007 18.117L5 18V14H1C0.755067 14 0.518663 13.91 0.335628 13.7473C0.152593 13.5845 0.0356572 13.3603 0.00699997 13.117L0 13V11C0.000136403 10.884 0.0204389 10.769 0.0599999 10.66L0.106 10.553L2 6.762V2C1.74512 1.99972 1.49997 1.90212 1.31463 1.72715C1.1293 1.55218 1.01777 1.31305 1.00283 1.05861C0.987891 0.804163 1.07067 0.553621 1.23426 0.358167C1.39786 0.162714 1.6299 0.0371036 1.883 0.00699997L2 0H10Z"
      [attr.fill]="hasGradient ? 'url(#' + gradientId + ')' : defaultColor"
    />
  </svg>
</div>
